import _ from 'lodash'
import { actionTypes as reduxFormActionTypes } from 'redux-form'
import { SET_FILTER_MEMORY } from '../apps/KpModule/actions'
import { FILTER_FORM } from '../apps/KpModule/components/Filter/FilterForm'

const isFilterAction = action =>
    action.type === SET_FILTER_MEMORY || (
        [reduxFormActionTypes.INITIALIZE, reduxFormActionTypes.CHANGE].includes(action.type) &&
        _.get(action, 'meta.form') === FILTER_FORM
    )

// Attaches the current module to filter actions so the filter reducer can
// store the filter values per module (see filterStorage).
export default ({ getState }) => next => action => {
    if (!action || !isFilterAction(action) || _.get(action, 'meta.module.id')) return next(action)

    const moduleId = _.get(getState(), 'module.id')
    if (!moduleId) return next(action)

    return next({
        ...action,
        meta: { ...action.meta, module: { id: moduleId } }
    })
}